module.exports = __webpack_public_path__ + "static/media/36-14.7442eef7.mp3";